import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgLucideUserRound = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <circle cx={12} cy={8} r={5} />
      <path d="M20 21a8 8 0 0 0-16 0" />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgLucideUserRound);
const Memo = memo(ForwardRef);
export default Memo;
